import React from 'react'
import MagazinArticleTile from '../molecules/MagazinArticleTile'

const MagazinArticles = ({ articles }) => {
  const renderArticleTile = article => (
    <MagazinArticleTile
      key={article.id}
      title={article.title}
      slug={article.slug}
      image={article.featureImage[0]}
    />
  )

  return (
    <section className="my-16 md:my-32">
      <div className="container">
        <div className="row-type-a2">
          <div className="space-y-16 md:space-y-32 col-1-type-a2">
            {articles
              .filter((_, index) => index % 2 === 0)
              .map(renderArticleTile)}
          </div>
          <div className="space-y-16 md:space-y-32 col-2-type-a2">
            {articles
              .filter((_, index) => index % 2 === 1)
              .map(renderArticleTile)}
          </div>
        </div>
      </div>
    </section>
  )
}

export default MagazinArticles
